import React from 'react';
import { Text, TextLink } from '@ads-core/components';

export const PostalCodesToggle = ({ postalCodes }: { postalCodes: string }) => {
  const [toggle, setToggle] = React.useState<boolean>(false);
  const limit = 3;
  const postalCodesArray = postalCodes?.split(',');

  return (
    <Text size="description">
      {postalCodesArray
        .slice(0, !toggle ? limit : postalCodes.length + 1)
        .map((postalCode, index) => {
          if (postalCodesArray.length > limit && !toggle) {
            return limit - 1 !== index ? `${postalCode}, ` : `${postalCode}... `;
          }

          return postalCodesArray.length - 1 !== index ? `${postalCode}, ` : `${postalCode} `;
        })}

      {postalCodesArray.length > limit ? (
        <TextLink onClick={() => setToggle(!toggle)} asChild>
          <button>
            {!toggle
              ? `+${postalCodesArray.length - limit}`
              : `-${postalCodesArray.length - limit}`}
          </button>
        </TextLink>
      ) : null}
    </Text>
  );
};
